export default __webpack_public_path__ + "static/media/elon.a3c9b965.jpeg";